<template>
  <div>
    <sidebar></sidebar>
    <navbar :pageIndex="pageIndex"></navbar>
    <div class="about-container">
      <div class="photos">
        <img src="@/assets/image/aboutus.jpg" alt="">
      </div>
      <div class="content">
          <p class="about-title">定制开发找蓝猿</p>
          <div class="about-text-1">
            <p>蓝猿BLUEAPE致力于微信小程序设计开发，微信公众</p>
            <p> 平台开发与代运营，品牌网站开发设计，app开发设计，专</p>
            <p>注创意，新颖，品质，捕捉时代热点加以创新开发。</p>
            <p class="about-text-1">
            团队每一员都抱着热忱的心对待每个新事物，专注，专心，
            专致，只为打造出每一款时代的科技新事物！
            </p>
          </div>
          <div class="about-text-2">这是一群90后青年创作团队，新科技，新生活，
            新未来，是我们一直坚持的理念。
          </div>
      </div>
      <div class="about-box-container">
        <div class="about-box" v-for="item in aboutBox">
          <div class="ab-box-title">{{item.title}}</div>
          <div class="ab-box-title-en">{{item.title_en}}</div>
          <div class="ab-box-detail">{{item.detail}}</div>
        </div>
      </div>
    </div>
    <myFooter></myFooter>
  </div>
</template>

<script>
  import navbar from "../../components/navbar";
  import myFooter from "../../components/myFooter";
  import sidebar from "../../components/sidebar";

  export default {
    name: "index",
    components: {
      navbar, myFooter,sidebar
    },
    data() {
      return {
        pageIndex: 4,
        aboutBox:[{
          title:'更加专业',
          title_en:'Professional',
          detail:`有手艺、懂业务、善创新，并不断要求自己更专业`
        },{
          title:'主动担当',
          title_en:'Ownership',
          detail:`把每件事当作自己的，全情投入、勇于担当、及时补位`
        },{
          title:'诚意服务',
          title_en:'Service',
          detail:`站在对方的角度思考，以服务赢得口碑，以服务赢得信任`
        },{
          title:'协作运行',
          title_en:'Execution',
          detail:`遇问题直接沟通，有结论后高效执行，过程中充分同步、协作`
        },{
          title:'追求结果',
          title_en:'Result',
          detail:`持续创造并获取价值，为结果买单`
        }]
      }
    }
  }
</script>

<style scoped>
  .about-container {
    margin-bottom: 60px;
  }
  .photos {
    width: 100%;
    height: 0;
    padding-bottom: 18.7%;
  }
  .photos img {
    width: 100%;
  }
  .content {
    width: 470px;
    margin: 0 auto;
    text-align: center;
    color: #353535;
  }

  .about-title {
    margin: 78px auto 0;
    font-size: 24px;
    font-weight: bold;
    line-height: 30px;
  }

  .about-text-1 {
    font-size: 16px;
    margin-top: 36px;
    letter-spacing: .1em;
    line-height: 160%;
  }
  .about-text-2{
    /*font-size: 24px;*/
    margin: 110px 0 60px;
  }
  .about-box-container{
    display: flex;
    justify-content: center;
  }
  .about-box{
    width: 174px;
    min-width: 136px;
    height: 204px;
    background-color: #f5f5f5;
    margin: 0 10px;
    color: #353535;
    padding: 26px;
    box-sizing: border-box;
  }
  .ab-box-title{
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 6px;
  }
  .ab-box-title-en{
    font-size: 12px;
    margin-bottom: 18px;
  }
  .ab-box-detail{
    font-size: 12px;
    line-height: 180%;
  }
</style>



// WEBPACK FOOTER //
// src/pages/about/index.vue